import React from 'react'

const WhyUs = () => {
  return (
    <div>
      
    </div>
  )
}

export default WhyUs
